// components/views/SettingsView.jsx
import { Callout, Icons } from '../UI';

export default function SettingsView({ profile, contracts, store }) {
  function exportData() {
    const data = { profile, contracts, exportedAt: new Date().toISOString(), version: '1.0' };
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = 'ca-contract-manager-backup-' + new Date().toISOString().split('T')[0] + '.json';
    document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
  }

  return (
    <div>
      <div className="page-header">
        <div className="page-header-left">
          <h1 className="page-title">Settings</h1>
          <p className="page-subtitle">AI service status, models used, and data management</p>
        </div>
      </div>

      {/* AI Service Status */}
      <div className="card">
        <h3 className="card-title">AI Services — Penny</h3>
        <p style={{ fontSize: 13, color: 'var(--slate-600)', marginBottom: 16, lineHeight: 1.7 }}>
          All Penny features — SOW drafting, compliance review, email generation, Ask Penny, and exemption analysis —
          are enabled for authenticated users. No API key configuration is required.
        </p>

        <Callout type="green">
          <strong>✓ AI services enabled.</strong> Your calls are routed through <code style={{ fontFamily: 'var(--font-mono)', background: 'var(--green-50)', padding: '1px 5px', borderRadius: 3 }}>api.goldenscope.app</code> using your secure GoldenScope session.
        </Callout>

        <div style={{ marginTop: 14, padding: '12px 14px', background: 'var(--slate-50)', borderRadius: 'var(--r-md)', fontSize: 12, color: 'var(--slate-600)', lineHeight: 1.7 }}>
          <strong>🔒 How this works:</strong> The Anthropic API key is stored server-side and is never exposed to your browser.
          Every AI call is authenticated against your Supabase login, logged for auditability, and cost-attributed to your agency.
          Administrators can review usage on the Super Admin dashboard.
        </div>
      </div>

      {/* Models used */}
      <div className="card">
        <h3 className="card-title">Penny — Models Used</h3>
        <div style={{ fontSize: 13, color: 'var(--slate-600)', lineHeight: 2 }}>
          {[
            ['SOW Studio (Options 1–3)', 'claude-haiku-4-5-20251001', 'Fast, cheap, good for structured drafts'],
            ['Contract Import (PDF extraction)', 'claude-haiku-4-5-20251001', 'Fast parsing of key fields'],
            ['Document Analysis', 'claude-haiku-4-5-20251001', 'Compliance review and feedback'],
            ['Procurement Rec, Solicitation, Compliance', 'claude-sonnet-4-6', 'Higher quality, more thorough'],
            ['Email & Letter Generation', 'claude-sonnet-4-6', 'Professional formal tone'],
            ['What\'s Next Panel', 'claude-sonnet-4-6', 'Contextual contract guidance'],
            ['Ask Pennying Memo (Analytics)', 'claude-sonnet-4-6', 'Executive summary quality'],
          ].map(([feature, model, note]) => (
            <div key={feature} style={{ display: 'grid', gridTemplateColumns: '220px 220px 1fr', gap: 12, padding: '6px 0', borderBottom: '1px solid var(--slate-100)' }}>
              <span style={{ fontWeight: 500, color: 'var(--slate-700)' }}>{feature}</span>
              <span style={{ fontFamily: 'var(--font-mono)', fontSize: 11.5, color: 'var(--navy-600)' }}>{model}</span>
              <span style={{ color: 'var(--slate-400)', fontSize: 12 }}>{note}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Data management */}
      <div className="card">
        <h3 className="card-title">Data Management</h3>
        <p style={{ fontSize: 13, color: 'var(--slate-600)', marginBottom: 16, lineHeight: 1.7 }}>
          All data is stored securely in Supabase. {contracts.length} contract{contracts.length !== 1 ? 's' : ''} saved.
        </p>
        <div className="btn-row">
          <button className="btn btn-ghost btn-sm" onClick={exportData}>
            <Icons.download /> Export All Data (JSON backup)
          </button>
        </div>
        <Callout type="blue" style={{ marginTop: 16 }}>
          <strong>Migrating to a team setup?</strong> When you're ready to share access with colleagues, replace <code style={{ fontFamily: 'var(--font-mono)', background: 'var(--blue-50)', padding: '1px 5px', borderRadius: 3 }}>src/utils/store.js</code> with the Supabase version. Your contracts export can be re-imported. Nothing else in the codebase needs to change.
        </Callout>
      </div>
    </div>
  );
}
